import { ActionDescriptor } from '../common/commonTypes';
import AggregateAttributeForm from './AggregateAttributeForm';

const aggregateAttribute: ActionDescriptor = {
	FormComponent: AggregateAttributeForm,
	actionTitle: 'Aggregate',
};

export default aggregateAttribute;
